/*
 * APIs are powered by PowerLego
 * Website: https://www.powerlego.com/
 */

import { POWERLEGO_API_URL, ACC_KEY } from "../config.ts";

/*
 * Address Validator
 * Use cases:        https://www.powerlego.com/cases/address_validator
 * Postman examples: https://documenter.getpostman.com/view/4831254/SzKYPH3c#ca1bdf1f-2318-4fed-aaeb-88708d7c34eb
 */
export const fetchGetProvider = async (zipcode) => {

  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

  const formdata = new FormData();
  formdata.append("zipcode", zipcode);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  const url = `${POWERLEGO_API_URL}/v2/utility_connect/get_provider`;

  const response = await fetch(url, requestOptions);
  return response.json();
};

export const fetchUtilityList = async (sort='') => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

  const formdata = new FormData();
  formdata.append("sort", sort);
  formdata.append("additional_data", true);
  formdata.append('page_size', '999')

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  const url = `${POWERLEGO_API_URL}/v2/utility_connect/available_utility_list`;
  const response = await fetch(url, requestOptions);
  return response.json();
};

export const fetchAllStateList = async () => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);


  const requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  const url = `${POWERLEGO_API_URL}/v2/utility_connect/states`;
  const response = await fetch(url, requestOptions);
  return response.json();
};
export const fetchAllData = async (params) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

  const formdata = new FormData();
  Object.keys(params).forEach((key) => formdata.append(key, params[key]));

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  const url = `${POWERLEGO_API_URL}/v2/utility_connect/ez_all_data`;
  const response = await fetch(url, requestOptions);
  return response.json();
};

export const fetchLogin = async (params) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

  const formdata = new FormData();
  Object.keys(params).forEach((key) => formdata.append(key, params[key]));

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  const url = `${POWERLEGO_API_URL}/v2/utility_connect/ez_login`;
  const response = await fetch(url, requestOptions);
  return response.json();
};

export const fetchAccountInformation = async (params) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

  const formdata = new FormData();
  Object.keys(params).forEach((key) => formdata.append(key, params[key]));

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  const url = `${POWERLEGO_API_URL}/v2/utility_connect/ez_account_information`;
  const response = await fetch(url, requestOptions);
  return response.json();
};

export const fetchTwoStepVerification = async (params) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

  const formdata = new FormData();
  Object.keys(params).forEach((key) => formdata.append(key, params[key]));

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  const url = `${POWERLEGO_API_URL}/v2/utility_connect/two_step_verification`;
  const response = await fetch(url, requestOptions);
  return response.json();
};

export const fetchAccountBill = async (params) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

  const formdata = new FormData();
  Object.keys(params).forEach((key) => formdata.append(key, params[key]));

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  const url = `${POWERLEGO_API_URL}/v2/utility_connect/ez_account_bill`;
  const response = await fetch(url, requestOptions);
  return response.json();
};

export const fetchAccountPayment = async (params) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

  const formdata = new FormData();
  Object.keys(params).forEach((key) => formdata.append(key, params[key]));

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  const url = `${POWERLEGO_API_URL}/v2/utility_connect/ez_account_payment`;
  const response = await fetch(url, requestOptions);
  return response.json();
};


export const fetchBillList = async (params) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

  const formdata = new FormData();
  Object.keys(params).forEach((key) => formdata.append(key, params[key]));

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  const url = `${POWERLEGO_API_URL}/v2/utility_connect/bill_list`;
  const response = await fetch(url, requestOptions);
  return response.json();
};

export const fetchUsageList = async (params) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

  const formdata = new FormData();
  Object.keys(params).forEach((key) => formdata.append(key, params[key]));
  formdata.append('is_direct', "false")

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  const url = `${POWERLEGO_API_URL}/v2/utility_connect/ez_usage`;
  const response = await fetch(url, requestOptions);
  return response.json();

  // return new Promise((resolve) => {
  //   setTimeout(() => {
  //     resolve(mockData);
  //   }, 2000);
  // });
};

export const verification = async (token, method) => {
  const myHeaders = new Headers();
  myHeaders.append("authorization", `Bearer ${ACC_KEY}`);

  const formdata = new FormData();
  formdata.append("token", token);
  formdata.append("method", method);
  const url = `${POWERLEGO_API_URL}/v2/utility_connect/verification`;

  const response = await fetch(url, {
    method: "POST",
    headers: myHeaders,
    redirect: "follow",
    body: formdata,
  });
  return response.json();
};

export const submit_verification = async (token, method, verification_code) => {
  const myHeaders = new Headers();
  myHeaders.append("authorization", `Bearer ${ACC_KEY}`);

  const formdata = new FormData();
  formdata.append("token", token);
  formdata.append("method", method);
  formdata.append("verification_code", verification_code);
  const url = `${POWERLEGO_API_URL}/v2/utility_connect/submit_verification`;

  const response = await fetch(url, {
    method: "POST",
    headers: myHeaders,
    redirect: "follow",
    body: formdata,
  });
  return response.json();
};

export const fetchCoverage = async (token) => {
  const myHeaders = new Headers();
  myHeaders.append("authorization", `Bearer ${ACC_KEY}`);

  const formdata = new FormData();
  formdata.append("token", token);
  const url = `${POWERLEGO_API_URL}/v2/utility_connect/coverage`;

  const response = await fetch(url, {
    method: "POST",
    headers: myHeaders,
    redirect: "follow",
    body: formdata,
  });
  return response.json();
};

export const download_pdf = async (token, file, isDownload = false,) => {
  const myHeaders = new Headers();
  myHeaders.append("authorization", `Bearer ${ACC_KEY}`);

  const formdata = new FormData();
  formdata.append("token", token);
  formdata.append("file", file);
  if (isDownload) {
    formdata.append("need_download", 'true');
  }
  const url = `${POWERLEGO_API_URL}/v2/utility_connect/download_pdf`;

  const response = await fetch(url, {
    method: "POST",
    headers: myHeaders,
    redirect: "follow",
    body: formdata,
  });
  return response.json();
};

export const contactUs = async (name, email, company, message) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

  const formdata = new FormData();
  formdata.append("site", 'utilityConnect');
  formdata.append("name", name);
  formdata.append("email", email);
  formdata.append("company", company);
  formdata.append("message", message);

  const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
  };

  const url = `https://www.powerlego.com/contact/website`

  const response = await fetch(url, requestOptions)
  return response.json()
}

export const fetchCoverageMenu = async () => {
  const myHeaders = new Headers();
  myHeaders.append("authorization", `Bearer ${ACC_KEY}`);

  const formdata = new FormData();
  const url = `${POWERLEGO_API_URL}/v2/utility_connect/list`;

  const response = await fetch(url, {
    method: "POST",
    headers: myHeaders,
    redirect: "follow",
    body: formdata,
  });
  return response.json();
};

export const getVerifyCode = async (type, contact, code) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);
  myHeaders.append("Content-Type", "application/json");

  const requestBody = JSON.stringify({
    contact: contact,
    type: type,
    code: code,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: requestBody,
    redirect: "follow",
  };

  const url = `${POWERLEGO_API_URL}/v2/two_factor/verifyCode`;
  const response = await fetch(url, requestOptions);
  return response.json();
};

export const getTwoFactorCode = async (phone) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);
  myHeaders.append("Content-Type", "application/json");

  const requestBody = JSON.stringify({
    contact: phone,
    type: "phone",
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: requestBody,
    redirect: "follow",
  };

  const url = `${POWERLEGO_API_URL}/v2/two_factor/sendcode`;
  const response = await fetch(url, requestOptions);
  return response.json();
};

export const fetchSendEmailCode = async (email) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);
  myHeaders.append("Content-Type", "application/json");

  const requestBody = JSON.stringify({
    contact: email,
    type: "email",
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: requestBody,
    redirect: "follow",
  };

  const url = `${POWERLEGO_API_URL}/v2/two_factor/sendcode`;
  const response = await fetch(url, requestOptions);
  return response.json();
};